import axios from '@_system/axios/axios.js'
export default {
	path: '/module',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	moduleConfig(app, module, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/moduleConfig/' + window.config.app + '/' + (app=='system'?'system.'+module:module), data, (res) => {
				resolve(res.data)
			}, reject, true)		
		})
	},
	moduleImporttemplate(app, module, data = {}) {
		return new Promise((resolve, reject) => {
				axios.post(this.path + '/moduleImporttemplate/' + window.config.app + '/' + (app=='system'?'system.'+module:module), data, (res) => {
					resolve(res.data)
				}, reject, true)
		})
	},
	moduleImport(app, module, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/moduleImport/' + window.config.app + '/' + (app=='system'?'system.'+module:module), data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	reaudit (app, module, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/moduleReaudit/' + window.config.app + '/' + (app=='system'?'system.'+module:module), data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},	
	retrieve (app, module, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/moduleRetrieve/' + window.config.app + '/' + (app=='system'?'system.'+module:module), data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},	
	// init(data = {}) {
	// 	return new Promise((resolve, reject) => {
	// 		axios.get(this.path + 'Init', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	}, reject, true)
	// },
}
